import type { Wrex } from '../../types';

export const isText = (node: any): node is Wrex.Text => node && typeof node.text === 'string';
